import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../../_metronic/layout/core";
import { SubscriptionTiersList } from "./SubscriptionTiersList";

const breadcrumbs: Array<PageLink> = [
  {
    title: "Subscription Tiers Management",
    path: "/subscription-tiers/list",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const SubscriptionTiersPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="list"
          element={
            <>
              <PageTitle breadcrumbs={breadcrumbs}>Subscription Tiers list</PageTitle>
              <SubscriptionTiersList/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to="/subscription-tiers/list" />} />
    </Routes>
  );
};

export default SubscriptionTiersPage;
